import { render, staticRenderFns } from "./SideForm.vue?vue&type=template&id=b3f68cb6&"
import script from "./SideForm.vue?vue&type=script&lang=js&"
export * from "./SideForm.vue?vue&type=script&lang=js&"
import style0 from "./SideForm.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports